import RetirementSVG from "../assets/retirementSVG";
import BuildWealthSVG from "../assets/buildWealth";
import MajorPurchaseSVG from "../assets/majorPurchase";
import EducationSVG from "../assets/educationSVG";

const GoalIcon = ({ type }) => {
  const getIcon = (goalType) => {
    switch (goalType) {
      case "Build Wealth":
        return <BuildWealthSVG height={100} />;
      case "Major Purchase":
        return <MajorPurchaseSVG height={100} />;
      case "Education":
        return <EducationSVG height={100} />;
      case "Retirement":
        return <RetirementSVG height={100} />;
      default:
        return <></>;
    }
  };

  return <>{getIcon(type)}</>;
};

export default GoalIcon;
